import columns from '../../react-table/helpers/columns';

export default (data) => {
  const {
    NonZeroNumberColumn,
    NumberColumn,
    TextColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('', 'name').withWidth(666.449),
        new NumberColumn('Generated From PREDES', 'generatedFromPredes').withWidth(127.283),
        new NumberColumn('Manual PRE-ADVISE', 'manualPreAdvice').withWidth(127.283),
        new NumberColumn('Central Repat', 'centralRepatriation').withWidth(127.283),
        new NonZeroNumberColumn('Total', 'total').withWidth(127.283),
        new NumberColumn('RFID Base Sleeve', 'rfidBaseSleeve').withWidth(127.283),
        new NumberColumn('RFID - EDI', 'rfidEdi').withWidth(509.132),
      ],
    },
  ];
};
